__turbopack_context__.v({
  "buttons": "_Uyn6q_buttons",
  "gradientOverlay": "_Uyn6q_gradientOverlay",
  "subtitle": "_Uyn6q_subtitle",
  "textStack": "_Uyn6q_textStack",
  "title": "_Uyn6q_title",
});
